import { Link, useNavigate } from "react-router-dom";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import PlusIcon from "../../../components/Icons/PlusIcon";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { useEffect, useRef, useState } from "react";
import EditIcon from "../../../components/Icons/EditIcon";
import DeleteIcon from "../../../components/Icons/DeleteIcon";
import { callApi } from "../../../ApiHelper/ApiHelper";
import ViewIcon from "../../../components/Icons/ViewIcon";
import { toast } from "react-toastify";
import MainHeading from "../../../components/comman/MainHeading";
import FilterComponent from "../../../components/comman/FilterComponent";
import CommonTable from "../../../components/comman/CommonTable";
import ConfirmModal from "../../../components/comman/ConfirmModal";
import { MainFilterHandler } from "../../../components/comman/MainFilterHandler";
import { useDispatch, useSelector } from "react-redux";
import { checkUserAccess } from "../../../utility/CommonFunctions";
import { updateFiltersStates } from "../../../store/actions/UserActions";

export default function SitesProject() {
  const navigate = useNavigate();
  const userDetails = useSelector((state) => state.root.userDetails);
  const dispatch = useDispatch();
  const filterDetails = useSelector((state) => state.root.filtersStates);
  const [isLoading, setIsLoading] = useState(false);
  const timeoutId = useRef(null);
  const [pageStates, setPageStates] = useState({
    currentPage: 1,
    pageSize: 10,
    count: 0,
    totalPages: 0,
    tableLoader: false,
    SiteData: [],
    filterData: "",
    searchQuery: "",
    type: "project",
  });

  useEffect(() => {
    GetSiteList(pageStates?.currentPage);
  }, [pageStates?.searchQuery, pageStates?.currentPage, pageStates.pageSize, filterDetails?.orderBy]);

  const GetSiteList = (pageNumber, filteredData) => {
    let options = {
      method: "GET",
    };
    let API =
      checkUserAccess(userDetails).isUserAccess ?
        apiUrl.get_site : apiUrl.get_user_site;;
    setPageStates((prev) => ({
      ...prev,
      tableLoader: true,
      SiteData: {},
    }));
    callApi(API + "?" + MainFilterHandler({ ...pageStates, orderBy: filterDetails?.orderBy }), options).then((response) => {
      setPageStates((prev) => ({
        ...prev,
        tableLoader: false,
      }));
      if (response?.status === true) {
        const newData = response?.data?.site?.map((item) => ({
          ...item,
          companyName: item?.Company?.name,
          ...(!checkUserAccess(userDetails).isUserAccess && { name: item?.site?.name }),
          ...(!checkUserAccess(userDetails).isUserAccess && { address: item?.site?.address }),
          ...(!checkUserAccess(userDetails).isUserAccess && { range: item?.site?.range }),
          ...(checkUserAccess(userDetails).isUserAccess ? { toggleStatus: item?.status } : { siteStatus: item?.site?.status }),
          isUserAccess: 1
        }))
        setPageStates((prevStates) => ({
          ...prevStates,
          SiteData: newData,
          count: response?.data?.pageInfo?.total,
          totalPages: response?.data?.pageInfo?.totalPages,
        }));
      }
    });
  };

  const PageChangeHandler = (PageNo) => {
    if (PageNo > 0 && PageNo <= pageStates?.totalPages) {
      setPageStates((prev) => ({
        ...prev,
        currentPage: PageNo,
      }));
      GetSiteList(PageNo, pageStates?.filterData);
    }
  };

  const handleChangePageSize = (value) => {
    setPageStates((prev) => ({
      ...prev,
      pageSize: value,
      currentPage: 1
    }));
  };

  const userAccess = checkUserAccess(userDetails).isUserAccess
  const HandleView = (data) => {
    if (userAccess) {
      navigate(`${RoutesLink?.site_detail}/${data?.id}`);
    } else {
      navigate(`${RoutesLink?.site_detail}/${data?.site?.id}`);
    }
  };

  const HandleUpdate = (data) => {
    navigate(RoutesLink?.add_site, { state: { data: data } })
  };

  const handleStatusToggle = (data, status) => {
    let formData = new FormData();
    formData.append("status", status ? 0 : 1);

    const options = {
      method: "POST",
      form_data: formData,
    };
    let API =
      apiUrl?.update_site + `?siteId=${data?.id}`;
    callApi(API, options).then((response) => {
      if (response?.status === true) {
        toast.success(response?.message);
        GetSiteList(pageStates?.currentPage);
      } else {
        toast.error(response?.message);
      }
    });
  }

  const status = checkUserAccess(userDetails).isUserAccess
    ? { value: "toggleStatus", label: "Status" }
    : { value: "siteStatus", label: "Status" };


  const TableHeading = [
    { value: "index", label: "SR NO." },
    { value: "name", label: "Site" },
    { value: "companyName", label: "Company" },
    { value: "address", label: "Address" },
    { value: "range", label: "Range" },
    status,
  ];



  const ActionData = [
    // {
    //   label: "View",
    //   className: "btn btn-link",
    //   icon: <ViewIcon />,
    //   title: "view",
    //   clickHandler: HandleView,
    // },
    // {
    //   label: "Edit",
    //   className: "btn btn-link",
    //   icon: <EditIcon />,
    //   isShow: false,
    //   isSiteEditable: userAccess ? true : false,
    //   title: "edit",
    //   clickHandler: HandleUpdate,
    // }
  ];

  const handleSearchChange = (e) => {
    const { value } = e.target;
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
    timeoutId.current = setTimeout(() => {
      setPageStates((prevState) => ({
        ...prevState,
        searchQuery: value
      }));
    }, 500);
  };

  const orderByHandler = (e) => {
    dispatch(
      updateFiltersStates({
        orderBy: e.target.value,
      })
    );
  };

  const orderByList = [
    { value: "", name: "Newest" },
    { value: "asc", name: "Oldest" },
  ];

  return (
    <>
      <>
        <MainHeading
          title={"Project Sites"}
          // buttonText={checkUserAccess(userDetails).isUserAccess && "Add New Site"}
          // buttonIcon={checkUserAccess(userDetails).isUserAccess && <PlusIcon />}
          // buttonLink={checkUserAccess(userDetails).isUserAccess && RoutesLink?.add_site}
          state={{ type: "project" }}
        />
        <div className="card mb-4">
          <div className="card-body">
            <FilterComponent handleSearch={handleSearchChange} searchPlaceHolder={"Search By Site Name"} orderByHandler={orderByHandler}
              orderByList={orderByList} />
            <CommonTable
              TableHeading={TableHeading}
              TableData={pageStates?.SiteData}
              ActionData={ActionData}
              currentPage={pageStates?.currentPage}
              PageChangeHandler={PageChangeHandler}
              isLoading={pageStates?.tableLoader}
              totalPages={pageStates?.totalPages}
              count={pageStates?.count}
              handleStatusToggle={handleStatusToggle}
              handleChangePageSize={handleChangePageSize}
              pageSize={pageStates.pageSize}
            />
          </div>
        </div>
      </>
    </>
  );
}
